import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Hidden from '@material-ui/core/Hidden';

import { getRequest } from 'utils/api';
import useIsAgency from 'hooks/useIsAgency';
import NavLink from 'components/NavLink';
import Badge from 'components/Badge';
import useIsInfluencer from 'hooks/useIsInfluencer';
import HomeIcon from 'public/icons/loggedInFooter/home.svg';
import GigsIcon from 'public/icons/loggedInFooter/gigs.svg';
import OrdersIcon from 'public/icons/loggedInFooter/orders.svg';
import DiscoverIcon from 'public/icons/loggedInFooter/discover.svg';
import AlertsIcon from 'public/icons/loggedInFooter/alerts.svg';
import styles from 'styles/components/LoggedInFooter.module.scss';

const LoggedInFooter = () => {
  const [counts, setCounts] = useState({});
  const currentUser = useSelector(state => state.auth.currentUser);
  const loggedIn = useSelector(state => state.auth.loggedIn);
  const isInfluencer = useIsInfluencer();
  const unseenNotificationsCount = useSelector(state => state.utils.unseenNotificationsCount);
  const isAgency = useIsAgency();

  useEffect(() => {
    if (loggedIn) {
      getRequest({
        endpoint: 'gigs/status_counts',
      })
        .then(response => setCounts(response))
        .catch(() => {});
    }

    return null;
  }, [loggedIn]);

  if (isAgency) return null;

  return (
    <Hidden mdUp>
      <footer className={styles.footer}>
        <div className={styles.container}>
          <NavLink href="/dashboard" activeClassName={styles.active} exact>
            <div className={styles.navIcons}>
              <HomeIcon width={30} height={30} alt="Home" />

              <span>Dashboard</span>
            </div>
          </NavLink>

          <NavLink href="/gigs" activeClassName={styles.active}>
            <div className={styles.navIcons}>
              <GigsIcon width={30} height={30} alt="Suitcase" />

              <span>Gigs</span>
            </div>
          </NavLink>

          <NavLink
            href={isInfluencer || currentUser.agency ? '/discover' : '/hire'}
            activeClassName={styles.active}
          >
            <div className={styles.navIcons}>
              <DiscoverIcon width={30} height={30} alt="Search" />

              <span>{isInfluencer || currentUser.agency ? 'Discover' : 'Hire'}</span>
            </div>
          </NavLink>

          <NavLink href="/offers" activeClassName={styles.active}>
            <Badge content={counts.orders} badgeStyles={{ top: '-5px', right: '-23px' }}>
              <div className={styles.navIcons}>
                <OrdersIcon width={30} height={30} alt="Orders" />

                <span>Offers</span>
              </div>
            </Badge>
          </NavLink>

          <NavLink href="/alerts" activeClassName={styles.active}>
            <Badge content={unseenNotificationsCount} badgeStyles={{ top: '-5px', right: '-18px' }}>
              <div className={styles.navIcons}>
                <AlertsIcon width={30} height={30} alt="Ringbell" />

                <span>Alerts</span>
              </div>
            </Badge>
          </NavLink>
        </div>
      </footer>
    </Hidden>
  );
};

export default LoggedInFooter;
